import { authorizedFetch } from "./requestBuilder.js";

const API_BASE = process.env.REACT_APP_API_URL + "/api/bids";

export const createBid = async (auctionId, bidAmount) => {
  try {
    // TODO check if phone verified

    return await authorizedFetch(`${API_BASE}/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        auctionId,
        bidAmount,
      }),
    });
  } catch (error) {
    console.error("Bid creation error:", error);
    throw error;
  }
};

// Get All Bids
export const getBids = async () => {
  try {
    return await authorizedFetch(`${API_BASE}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
  } catch (error) {
    console.error("Error fetching bids:", error);
    throw error;
  }
};

// Get My Bids
export const getMyBids = async () => {
  try {
    return await authorizedFetch(`${API_BASE}/my`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("Error fetching bids:", error);
    throw error;
  }
};
